// useDwtBell: feeds the Digital Waste Tracking items of the TopBar bell.
//
// Admin only. The Collections counts arrive over SSE for everyone in the company, so
// the DWT numbers (which only admins may see, and which change when the background
// worker runs rather than when someone clicks) are fetched separately and refreshed
// every minute while the bell is on screen.

import { useEffect } from 'react';

import { fetchDwtBell } from '../api/dwt';
import { useAuthStore } from '../store/authStore';
import { useCollectionsNotifStore } from '../store/collectionsNotifStore';

export const DWT_BELL_REFRESH_MS = 60_000;

export function useDwtBell(): void {
  const role = useAuthStore((s) => s.user?.role);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const setDwt = useCollectionsNotifStore((s) => s.setDwt);
  const enabled = isAuthenticated && role === 'admin';

  useEffect(() => {
    if (!enabled) {
      setDwt(null);
      return;
    }
    let cancelled = false;
    const load = (): void => {
      fetchDwtBell()
        .then((b) => {
          if (cancelled) return;
          setDwt(b === null ? null : { unknownOutcomes: b.unknown_outcomes, overdue: b.overdue, paused: b.paused });
        })
        .catch(() => {
          // Non-fatal: keep whatever was shown; the next tick tries again.
        });
    };
    load();
    const timer = setInterval(load, DWT_BELL_REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [enabled, setDwt]);
}
